// List-filter values the API reads the same way on every list endpoint
// (api/app/lib/filters): `?field=null` asks for the rows whose column is NULL,
// `?field_ne=null` for the rows whose column is not.

/** The filter value that means SQL NULL (filters.NullValue). */
export const NULL_VALUE = "null";
